'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.daysAfter;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/daysAfter.js
// module id = 157
// module chunks = 0